import { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { DevHubTextField, DevHubMenuItem } from '@devxdiscover/devhub-ui';
import { ServiceDomain } from './types/InsightsTypes';

const GetDomainsQuery = gql`
  query PortfolioItems {
    resources {
      portfolioItems {
        id
        name
      }
    }
  }
`;

interface Props {
  handleChange: any;
  value: any;
  helperText?: string;
}

/**
 * Component to display selection box of ITRC service domains
 * @param props props of the component
 * @param props.value default value of the select box
 * @param props.handleChange the event handler to set and store the domain
 * @param props.helperText the helper text to display below the select box
 */
function ServiceDomains(props: Props) {
  const [serviceDomains, setServiceDomains] = useState([]);

  const { data } = useQuery(GetDomainsQuery, {
    errorPolicy: 'all',
  });

  useEffect(() => {
    setServiceDomains(data?.resources?.portfolioItems);
  }, [data]);

  return (
    <DevHubTextField
      name="serviceDomain"
      size="small"
      select
      variant="outlined"
      onChange={props?.handleChange}
      label="Select new domain"
      helperText={props?.helperText}
      value={props?.value}
    >
      {serviceDomains?.map((option: ServiceDomain) => {
        return (
          <DevHubMenuItem key={option?.id} value={option?.id}>
            {option?.name}
          </DevHubMenuItem>
        );
      })}
    </DevHubTextField>
  );
}

export default ServiceDomains;
